<template>
  <!-- 页面头部公共组件 -->
  <div class="main_wrapper">
    <div class="title_wrapper">
      <!-- 标题，接收父组件传值，默认为空 -->
      <span class="title_item">{{title}}</span>
    </div>
    <div class="btn_wrapper"
         @click="back">
      <!-- 返回按钮 -->
      <!-- <div class="btn_item">{{ $t('m.goBack') }}</div> -->
      <!-- 返回<i class="el-icon-right"></i> -->
      <!-- <el-button type="primary"
                 plain
                 @click="back">
        返回
        <svg-icon
                  style="width: 15pt; height: 15pt"
                  icon-class="返回" />
      </el-button> -->
      <svg-icon style="width: 22pt; height: 22pt;"
                icon-class="fanhui" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  data () {
    return {
      // title: ''
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  methods: {
    // 返回上级，调用父组件返回方法
    back () {
      this.$emit('back', false)
    }
  }
}
</script>

<style lang="less" scoped>
.main_wrapper {
    width: 100%;
    height: 7vh;
    display: flex;
    padding: 0 2vh;
    color: #fff;
    font-size: 14px;
    align-items: center;
    border-bottom: 1px #ddd solid;
    justify-content: space-between;
    background: linear-gradient(to right, #048ef2, #fff);
    .title_wrapper {
        height: 100%;
        display: flex;
        padding-top: 0.5vh;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title_item {
            font-size: 14px;
            font-weight: bold;
        }
    }
    .btn_wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 70%;
        width: 7vh;
        border-radius: 10px;
        margin-top: 0.4vh;
        // background-color: #f9fafc;
        svg {
            &:hover {
                cursor: pointer;
            }
        }
        &:hover {
            cursor: pointer;
        }
        .btn_item {
            margin-right: 1vh;
        }
        .el-icon-right {
            margin-top: 0.2vh;
        }
    }
}
</style>
